import { DEFAULT_IMAGES } from '../constants/images.constants';
import { Gender } from '../models/gender.enum';
import { parseSafeDate } from './date.utils';

// Get the correct image based on gender and selection state
export const getDefaultFighterImage = (gender: Gender | unknown): string => {
  if (gender === Gender.F) {
    return DEFAULT_IMAGES.FIGHTER_FEMALE;
  } else if (gender === Gender.M) {
    return DEFAULT_IMAGES.FIGHTER_MALE;
  }
  return DEFAULT_IMAGES.FIGHTER_GENERIC;
};

// Build fighter key that handles missing names gracefully
export const buildFighterKey = (
  firstName?: string,
  lastName?: string,
  dob?: Date,
): string | null => {
  if (!dob) return null;

  // Format the date consistently as YYYY-MM-DD using our safe date parser
  const safeDate = parseSafeDate(dob);
  const formattedDate = safeDate.toISOString().split('T')[0];

  // Clean up names by replacing spaces with underscores
  const cleanFirstName = firstName?.replace(/\s+/g, '_');
  const cleanLastName = lastName?.replace(/\s+/g, '_');

  // If we have both names, use the original format
  if (cleanFirstName && cleanLastName) {
    return `${cleanFirstName}_${cleanLastName}_${formattedDate}`;
  }

  // If we only have one name, use that name with dob
  if (cleanFirstName && !cleanLastName) {
    return `${cleanFirstName}_${formattedDate}`;
  }

  if (!cleanFirstName && cleanLastName) {
    return `${cleanLastName}_${formattedDate}`;
  }

  // If no names at all, we can't build a meaningful key
  return null;
};

// Build URL path for fighter image that handles missing names
export const buildFighterImagePath = (
  firstName?: string,
  lastName?: string,
  dob?: Date,
): string | null => {
  const key = buildFighterKey(firstName, lastName, dob);
  if (!key) return null;

  return `${key.toLowerCase()}.png`;
};
